import { render, staticRenderFns } from "./ProjectsOverviewTabs.vue?vue&type=template&id=21518782&scoped=true&"
import script from "./ProjectsOverviewTabs.vue?vue&type=script&lang=js&"
export * from "./ProjectsOverviewTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsOverviewTabs.vue?vue&type=style&index=0&id=21518782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21518782",
  null
  
)

export default component.exports